var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMockInterview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 308,
    viewBox: "0 0 351 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H340C345.523 0 350 4.47715 350 10V290C350 295.523 345.523 300 340 300H10C4.47715 300 0 295.523 0 290V10Z",
    fill: "#92E3A9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_2282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.192 132.764C292.192 132.764 298.829 176.876 265.178 211.964C231.527 247.052 177.748 257.312 134.42 266.66C91.0915 276.008 53.0947 257.786 41.4851 223.4C29.8755 189.014 61.4659 173.648 72.2051 130.886C82.9443 88.124 78.8675 75.2 112.788 44.798C146.708 14.396 209.652 20.516 249.031 57.998C288.41 95.48 292.192 132.764 292.192 132.764Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M292.192 132.764C292.192 132.764 298.829 176.876 265.178 211.964C231.527 247.052 177.748 257.312 134.42 266.66C91.0915 276.008 53.0947 257.786 41.4851 223.4C29.8755 189.014 61.4659 173.648 72.2051 130.886C82.9443 88.124 78.8675 75.2 112.788 44.798C146.708 14.396 209.652 20.516 249.031 57.998C288.41 95.48 292.192 132.764 292.192 132.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.21 218.864H295.162",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.21 173.084H295.162",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.21 127.298H295.162",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.21 81.512H295.162",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8595 55.514V218.978",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.906 55.514V218.978",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.613 116.108L99.6995 118.004",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.311 83.78L103.93 113.822",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.205 88.67L119.136 105.116",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.536 116.108L255.623 118.004",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.234 83.78L259.853 113.822",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.128 88.67L275.059 105.116",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3379 208.568L31.4243 210.464",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0356 176.234L35.6548 206.282",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9299 181.124L50.8611 197.57",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4708 76.994L56.5508 78.89",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1618 44.66L60.781 74.702",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0627 49.55L75.9939 65.996",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.551 76.994L198.631 78.89",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.242 44.66L202.861 74.702",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.143 49.55L218.074 65.996",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.615 163.67L154.701 165.566",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.312 131.342L158.932 161.384",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.207 136.232L174.138 152.678",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.951 102.008H174.752C177.893 102.008 180.904 103.177 183.125 105.259C185.345 107.341 186.592 110.164 186.592 113.108V210.014H127.111V113.102C127.113 110.159 128.361 107.337 130.581 105.257C132.801 103.177 135.812 102.008 138.951 102.008Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.607 266.72L162.189 258.056V248.414H160.416V212.816H154.836V248.414H153.063V257.798L121.645 266.72V268.13H122.068C121.825 268.546 121.7 269.012 121.703 269.486C121.701 269.984 121.837 270.474 122.099 270.907C122.36 271.341 122.737 271.703 123.193 271.958C123.649 272.214 124.168 272.354 124.699 272.364C125.23 272.374 125.755 272.255 126.221 272.017C126.688 271.78 127.081 271.432 127.361 271.009C127.641 270.586 127.799 270.102 127.819 269.605C127.839 269.107 127.721 268.613 127.475 268.171C127.23 267.73 126.866 267.356 126.42 267.086L126.484 267.026L155.284 263.78V267.668C154.915 268.088 154.681 268.597 154.61 269.136C154.538 269.676 154.631 270.224 154.879 270.715C155.126 271.207 155.518 271.622 156.008 271.913C156.497 272.205 157.065 272.359 157.645 272.359C158.225 272.359 158.793 272.205 159.283 271.913C159.773 271.622 160.164 271.207 160.412 270.715C160.659 270.224 160.753 269.676 160.681 269.136C160.609 268.597 160.376 268.088 160.007 267.668V263.78L188.743 267.02C188.226 267.305 187.81 267.727 187.547 268.232C187.284 268.738 187.185 269.304 187.263 269.862C187.34 270.419 187.591 270.943 187.984 271.368C188.376 271.793 188.893 272.101 189.471 272.253C190.048 272.404 190.661 272.393 191.232 272.221C191.803 272.049 192.307 271.724 192.683 271.285C193.058 270.847 193.287 270.314 193.342 269.754C193.397 269.194 193.276 268.632 192.992 268.136H193.632L193.607 266.72Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.749 209.954H130.055C127.482 209.954 125.396 211.91 125.396 214.322V218.72C125.396 221.132 127.482 223.088 130.055 223.088H184.749C187.322 223.088 189.408 221.132 189.408 218.72V214.322C189.408 211.91 187.322 209.954 184.749 209.954Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.167 188.654H135.706V211.832H180.167V188.654Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.863 121.946L147.053 124.448C147.053 124.448 149.517 138.794 152.813 146.198C156.109 153.602 168.116 165.356 168.116 165.356C168.116 165.356 174.336 156.842 176.506 150.086C178.676 143.33 176.41 124.352 176.41 124.352C174.858 123.505 173.149 122.939 171.373 122.684C168.282 122.222 153.863 121.946 153.863 121.946Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.48 132.038L163.629 137.708L158.407 148.514L166.797 160.358L171.93 149.528L165.709 137.498L168.967 132.218L164.327 127.868L160.48 132.038Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.855 121.298L152.679 121.856L150.605 125.276L155.725 138.884L164.122 130.742L173.3 139.532C173.3 139.532 174.388 125.834 174.388 124.262C174.388 122.69 172.909 122.132 171.828 121.862C170.746 121.592 154.855 121.298 154.855 121.298Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.679 121.856C152.679 121.856 153.62 134.162 159.079 144.992C161.901 150.572 167.175 158.414 167.175 158.138C167.175 157.862 172.404 143.33 172.602 138.422C172.8 133.514 173.786 123.056 173.786 123.056C173.786 123.056 183.911 126.836 186.33 128.15C190.08 130.184 194.816 130.646 194.72 133.052C194.682 133.928 195.322 139.652 196.135 146.63C196.263 147.74 202.618 157.262 202.752 158.414C204.116 170.036 199.488 174.932 199.258 174.986C198.868 175.076 190.669 174.986 190.669 174.986C190.669 174.986 195.117 193.958 195.789 194.978L196.48 195.992H161.21L159.738 191.828L158.426 195.992H122.17L127.008 175.352H121.677C121.677 175.352 120.295 172.76 122.17 163.04C124.045 153.32 130.368 128.978 130.368 128.15C130.368 127.322 150.605 123.89 152.679 121.856Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.218 169.946L159.738 191.828",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.805 161.654C179.636 156.566 182.202 146.384 182.202 146.384L176.967 144.254L182.004 141.938L177.652 124.538C175.188 122.546 173.741 122.6 173.812 123.038C173.812 123.038 172.826 133.496 172.628 138.404C172.429 143.312 167.188 157.862 167.188 158.138C167.188 158.414 161.383 150.782 159.092 144.992C153.754 131.516 152.73 123.392 152.576 121.838C152.575 121.812 152.566 121.787 152.55 121.766C152.535 121.745 152.514 121.728 152.489 121.717C152.464 121.706 152.437 121.701 152.409 121.703C152.382 121.706 152.356 121.715 152.333 121.73C151.597 122.138 149.773 122.474 148.493 123.53C148.135 125.93 147.674 129.41 147.354 133.238C146.765 140.366 146.765 143.51 146.765 143.51L153.575 145.088L148.736 147.68C148.736 147.68 154.068 152.768 158.509 156.566C162.951 160.364 165.908 161.744 165.908 161.744L160.218 169.946C160.218 169.946 167.981 166.748 173.805 161.654Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.863 115.19V123.152C153.863 123.152 156.039 129.812 163.738 130.274C171.834 130.766 173.217 123.428 173.217 123.428V116.39C173.217 116.39 158.228 119.816 153.863 115.19Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.092 104.45C175.092 104.45 175.386 100.85 177.754 100.85C180.122 100.85 180.129 105.014 179.533 106.682C178.938 108.35 175.879 109.55 174.893 108.254",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.092 104.45C175.092 104.45 175.386 100.85 177.754 100.85C180.122 100.85 180.129 105.014 179.533 106.682C178.938 108.35 175.879 109.55 174.893 108.254",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.268 86.432C165.268 86.432 156.544 86.132 153.53 88.232C150.516 90.332 151.149 95.966 151.149 97.748C151.149 99.53 152.576 114.848 153.53 117.08C154.484 119.312 161.428 122.708 167.482 121.4C173.536 120.092 175.412 116.048 175.725 113.966C176.039 111.884 176.045 95.966 175.725 91.814C175.405 87.662 169.543 86.876 165.268 86.432Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.815 93.44C175.815 92.78 175.764 92.24 175.725 91.784C175.412 87.62 169.543 86.876 165.261 86.432C165.261 86.432 156.538 86.132 153.524 88.232C150.509 90.332 151.143 95.966 151.143 97.748C151.143 98.462 151.373 101.348 151.713 104.684C151.865 104.765 152.036 104.811 152.211 104.819C152.386 104.827 152.561 104.796 152.721 104.73C152.881 104.664 153.023 104.563 153.135 104.436C153.246 104.31 153.325 104.16 153.364 104C154.004 102.362 153.05 100.88 153.844 98.798C154.637 96.716 154.951 95.378 156.858 94.334C158.054 93.6917 159.331 93.1938 160.66 92.852C160.66 92.852 156.698 97.16 165.421 97.01C171.085 96.89 174.279 95.786 175.815 93.44Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.996 101.03C166.996 101.03 168.474 107.6 167.092 108.23C165.709 108.86 164.826 109.064 163.636 106.844",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.296 108.152C159.296 108.152 158.996 111.212 165.613 110.744",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.37 101.168C161.37 101.804 161.082 102.326 160.73 102.326C160.378 102.326 160.09 101.804 160.09 101.168C160.09 100.532 160.378 100.01 160.73 100.01C161.082 100.01 161.37 100.526 161.37 101.168Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29 101.168C171.29 101.804 171.002 102.326 170.65 102.326C170.298 102.326 170.01 101.804 170.01 101.168C170.01 100.532 170.298 100.01 170.65 100.01C171.002 100.01 171.29 100.526 171.29 101.168Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.88 103.898H157.517C157.24 103.897 156.971 103.805 156.757 103.639C156.543 103.473 156.398 103.242 156.346 102.986L155.642 99.452H164.525L164.064 102.92C164.027 103.19 163.887 103.438 163.669 103.618C163.451 103.798 163.171 103.897 162.88 103.898Z",
    stroke: "#263238",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.336 103.898H168.973C168.695 103.898 168.426 103.807 168.212 103.64C167.998 103.474 167.853 103.242 167.802 102.986L167.092 99.452H175.981L175.508 102.92C175.471 103.188 175.332 103.434 175.117 103.614C174.902 103.794 174.625 103.894 174.336 103.898Z",
    stroke: "#263238",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.525 99.452H167.092",
    stroke: "#263238",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.642 99.452L151.399 101.21",
    stroke: "#263238",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.384 104.45C152.384 104.45 152.09 100.85 149.716 100.85C147.341 100.85 147.348 105.014 147.943 106.682C148.538 108.35 151.591 109.55 152.583 108.254",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.384 104.45C152.384 104.45 152.09 100.85 149.716 100.85C147.341 100.85 147.348 105.014 147.943 106.682C148.538 108.35 151.591 109.55 152.583 108.254",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.952 150.638C176.617 149.457 174.99 148.605 173.216 148.16C172.643 147.974 172.028 147.929 171.431 148.028C170.637 148.028 166.701 146.696 165.716 146.42C164.73 146.144 164.135 147.068 164.436 148.088C164.736 149.108 166.842 149.972 167.636 150.158C168.429 150.344 168.09 150.362 168.09 150.362C168.09 150.362 169.37 153.326 168.781 154.436C168.192 155.546 166.112 158.036 166.804 159.806C167.495 161.576 168.583 162.488 170.752 162.488C172.922 162.488 174.208 162.578 174.701 162.488C175.194 162.398 183.981 166.466 183.021 166.562C182.061 166.658 182.624 158.324 182.624 158.324L177.952 150.638Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.01 155.546C158.01 155.546 162.65 153.416 164.922 151.286C167.194 149.156 167.981 148.604 168.762 148.418C169.543 148.232 172.711 147.398 173.498 146.75C174.285 146.102 174.88 147.308 173.696 148.232C172.831 148.892 171.906 149.48 170.932 149.99C170.439 150.272 169.946 151.568 169.946 151.568C169.946 151.568 174.784 149.624 176.461 150.086C178.138 150.548 179.802 151.952 179.7 152.78C179.597 153.608 179.29 153.212 178.202 153.116C177.114 153.02 175.572 152.582 174.362 153.044C173.152 153.506 171.802 154.622 171.802 155.084C171.802 155.546 173.184 155.822 174.272 155.732C175.36 155.642 176.148 155.36 177.229 155.546C178.311 155.732 179.207 156.284 179.303 156.842C179.399 157.4 178.912 157.394 177.722 157.49C176.532 157.586 174.464 157.676 173.773 158.138C173.082 158.6 169.53 160.172 170.125 160.73C170.72 161.288 171.072 161.288 172.256 161.288C173.44 161.288 174.708 160.436 175.399 160.484C176.327 160.55 176.826 160.616 176.826 160.616C176.826 160.616 178.471 160.682 178.324 161.288C178.093 162.26 177.543 162.29 175.156 162.392C173.287 162.476 172.788 162.302 171.111 162.674C169.673 163.108 168.179 163.356 166.669 163.412C163.802 163.598 158.669 162.302 158.669 162.302L158.01 155.546Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.64 149.504C176.64 149.504 174.644 147.758 173.498 147.704C172.352 147.65 168.858 150.518 168.378 151.592C167.898 152.666 169.018 152.258 169.946 151.994C170.874 151.73 173.376 150.65 174.234 150.32C174.935 149.996 175.736 149.918 176.493 150.098",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.64 149.504C176.64 149.504 174.644 147.758 173.498 147.704C172.352 147.65 168.858 150.518 168.378 151.592C167.898 152.666 169.018 152.258 169.946 151.994C170.874 151.73 173.376 150.65 174.234 150.32C174.935 149.996 175.736 149.918 176.493 150.098",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.213 153.32C179.213 153.32 176.359 151.982 174.573 152.72C172.788 153.458 170.573 154.934 170.573 155.6C170.573 156.266 170.932 156.14 172.493 156.068C174.055 155.996 176.877 155.57 177.255 155.552C177.82 155.613 178.379 155.719 178.925 155.87",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.213 153.32C179.213 153.32 176.359 151.982 174.573 152.72C172.788 153.458 170.573 154.934 170.573 155.6C170.573 156.266 170.932 156.14 172.493 156.068C174.055 155.996 176.877 155.57 177.255 155.552C177.82 155.613 178.379 155.719 178.925 155.87",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.156 145.274L136.685 157.676C136.685 157.676 158.112 153.692 158.9 154.25C159.687 154.808 160.404 169.526 160.404 169.526C160.404 169.526 132.736 174.056 129.479 175.076C126.221 176.096 122.861 176.276 121.677 175.352C120.493 174.428 120.397 172.112 121.28 167.552C122.164 162.992 130.663 129.884 130.663 129.884",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.156 145.274L136.685 157.676C136.685 157.676 158.112 153.692 158.9 154.25C159.687 154.808 160.404 169.526 160.404 169.526C160.404 169.526 132.736 174.056 129.479 175.076C126.221 176.096 122.861 176.276 121.677 175.352C120.493 174.428 120.397 172.112 121.28 167.552C122.164 162.992 130.663 129.884 130.663 129.884",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.813 144.44L189.703 158.6L182.593 158.324L181.908 170.06C181.908 170.06 201.505 174.338 202.593 174.86C203.681 175.382 203.482 174.308 204.762 172.544C206.042 170.78 207.137 166.994 207.034 165.344C206.932 163.694 202.887 158.144 202.791 158.402",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.813 144.44L189.703 158.6L182.593 158.324L181.908 170.06C181.908 170.06 201.505 174.338 202.593 174.86C203.681 175.382 203.482 174.308 204.762 172.544C206.042 170.78 207.137 166.994 207.034 165.344C206.932 163.694 202.887 158.144 202.791 158.402",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.703 158.6H196.32",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.685 157.676L127.898 160.544",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 258.026C138.784 258.026 137.351 263.804 135.348 265.826C133.344 267.848 131.508 269.186 131.623 270.794L131.764 272.408H152.384V267.56C152.384 264.74 151.104 259.76 151.104 257.762C151.104 255.764 138.215 257.894 138.215 257.894",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.784 258.026C138.784 258.026 137.351 263.804 135.348 265.826C133.344 267.848 131.508 269.186 131.623 270.794L131.764 272.408H152.384V267.56C152.384 264.74 151.104 259.76 151.104 257.762C151.104 255.764 138.215 257.894 138.215 257.894",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.116 269.174C131.765 269.644 131.592 270.21 131.623 270.782L131.764 272.396H152.384V269.174H132.116Z",
    fill: "#586166",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.685 206.744C156.685 206.744 158.688 194.798 155.252 189.296C151.815 183.794 139.783 183.656 133.056 187.412C126.33 191.168 123.712 197.33 126.144 205.25C128.576 213.17 134.202 213.326 134.202 213.326C134.202 213.326 132.768 224.198 132.768 228.494C132.768 232.79 137.639 259.508 137.639 259.508H151.828C151.828 259.508 156.397 212.384 156.685 206.744Z",
    fill: "#586166",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.202 213.326L135.629 202.316",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 258.026C180.468 258.026 181.901 263.804 183.904 265.826C185.908 267.848 187.744 269.186 187.629 270.794L187.488 272.408H166.868V267.56C166.868 264.74 168.148 259.76 168.148 257.762C168.148 255.764 181.037 257.894 181.037 257.894",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 258.026C180.468 258.026 181.901 263.804 183.904 265.826C185.908 267.848 187.744 269.186 187.629 270.794L187.488 272.408H166.868V267.56C166.868 264.74 168.148 259.76 168.148 257.762C168.148 255.764 181.037 257.894 181.037 257.894",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.13 269.174C187.482 269.643 187.658 270.209 187.629 270.782L187.488 272.396H166.868V269.174H187.13Z",
    fill: "#586166",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.567 206.744C162.567 206.744 160.564 194.798 164 189.296C167.437 183.794 179.469 183.656 186.196 187.412C192.922 191.168 195.597 197.33 193.159 205.25C190.72 213.17 185.05 213.326 185.05 213.326C185.05 213.326 186.484 224.198 186.484 228.494C186.484 232.79 181.613 259.508 181.613 259.508H167.437C167.437 259.508 162.855 212.384 162.567 206.744Z",
    fill: "#586166",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.05 213.326L183.616 202.316",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.904 64.502H220.231C221.032 64.502 221.8 64.8004 222.367 65.3315C222.933 65.8626 223.252 66.5829 223.252 67.334V79.658C223.252 80.4091 222.933 81.1294 222.367 81.6605C221.8 82.1916 221.032 82.49 220.231 82.49H211.725L213.946 88.13L206.951 82.49H191.904C191.508 82.49 191.115 82.4167 190.748 82.2744C190.382 82.1321 190.049 81.9235 189.768 81.6605C189.488 81.3975 189.265 81.0853 189.113 80.7417C188.962 80.3981 188.884 80.0299 188.884 79.658V67.334C188.884 66.9621 188.962 66.5938 189.113 66.2502C189.265 65.9066 189.488 65.5944 189.768 65.3315C190.049 65.0685 190.382 64.8599 190.748 64.7176C191.115 64.5752 191.508 64.502 191.904 64.502Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.159 74.702C214.067 74.702 214.804 74.0116 214.804 73.16C214.804 72.3084 214.067 71.618 213.159 71.618C212.25 71.618 211.514 72.3084 211.514 73.16C211.514 74.0116 212.25 74.702 213.159 74.702Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.28 74.702C206.189 74.702 206.925 74.0116 206.925 73.16C206.925 72.3084 206.189 71.618 205.28 71.618C204.372 71.618 203.636 72.3084 203.636 73.16C203.636 74.0116 204.372 74.702 205.28 74.702Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.408 74.702C198.317 74.702 199.053 74.0116 199.053 73.16C199.053 72.3084 198.317 71.618 197.408 71.618C196.5 71.618 195.764 72.3084 195.764 73.16C195.764 74.0116 196.5 74.702 197.408 74.702Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8563 164.78L76.8835 174.626H90.9827L95.9555 165.26L81.8563 164.78Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.813 164.78H81.8563L86.8355 174.626H117.786L112.813 164.78Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7988 188.186H50.8228V272.36H57.7988V188.186Z",
    fill: "#A3A3A3",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.095 188.402H274.119V272.576H281.095V188.402Z",
    fill: "#A3A3A3",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16 174.356H49.3059V255.482H284.16V174.356Z",
    fill: "#A3A3A3",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16 174.356H49.3059V182.798H284.16V174.356Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.144 174.356H43.3284V179.39H290.144V174.356Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0692 248.684C53.0692 248.684 37.2164 217.028 40.666 216.11C44.1156 215.192 51.3476 220.238 51.3476 220.238C51.3476 220.238 30.138 167 35.6228 162.896C41.1076 158.792 51.3476 179.87 51.3476 179.87C51.3476 179.87 40.41 147.296 41.6964 134.906C42.9828 122.516 56.8772 134.45 56.8772 134.45C56.8772 134.45 45.7476 89.948 56.0772 87.65C66.4068 85.352 66.0676 138.578 66.0676 138.578C66.0676 138.578 69.4596 100.502 73.6004 111.05C77.7412 121.598 69.0372 156.932 69.0372 156.932C69.0372 156.932 74.714 145.004 77.8692 156.014C81.0244 167.024 71.5972 211.52 71.5972 211.52C71.5972 211.52 79.61 204.182 80.3588 213.356C81.1076 222.53 63.7764 251 63.7764 251L53.9716 251.894L53.0692 248.684Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M53.0692 248.684C53.0692 248.684 37.2164 217.028 40.666 216.11C44.1156 215.192 51.3476 220.238 51.3476 220.238C51.3476 220.238 30.138 167 35.6228 162.896C41.1076 158.792 51.3476 179.87 51.3476 179.87C51.3476 179.87 40.41 147.296 41.6964 134.906C42.9828 122.516 56.8772 134.45 56.8772 134.45C56.8772 134.45 45.7476 89.948 56.0772 87.65C66.4068 85.352 66.0676 138.578 66.0676 138.578C66.0676 138.578 69.4596 100.502 73.6004 111.05C77.7412 121.598 69.0372 156.932 69.0372 156.932C69.0372 156.932 74.714 145.004 77.8692 156.014C81.0244 167.024 71.5972 211.52 71.5972 211.52C71.5972 211.52 79.61 204.182 80.3588 213.356C81.1076 222.53 63.7764 251 63.7764 251L53.9716 251.894L53.0692 248.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4675 250.058C56.4675 250.058 43.2515 228.038 45.7027 223.91C48.1539 219.782 55.4755 229.4 55.4755 229.4C55.4755 229.4 38.8355 190.4 41.2867 186.74C43.7379 183.08 51.5267 199.124 51.5267 199.124C51.5267 199.124 48.5955 145.448 53.4851 147.284C58.3747 149.12 58.8996 174.8 58.8996 174.8C58.8996 174.8 55.9619 113.78 60.3715 115.616C64.7811 117.452 64.2819 185.348 64.2819 185.348C64.2819 185.348 73.1075 159.2 74.5603 171.152C76.0131 183.104 63.3027 215.192 63.3027 215.192C63.3027 215.192 75.5395 189.962 77.0051 203.264C78.4707 216.566 67.2196 241.34 67.2196 241.34C67.2196 241.34 71.6227 231.248 71.6227 236.756C71.6227 242.264 68.1987 249.14 68.1987 249.14",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3172 249.884H46.3428V272.576H74.3172V249.884Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.853 96.308C227.853 96.308 224.986 100.742 224.557 102.752C224.128 104.762 224.845 105.572 224.269 107.048C223.693 108.524 221.268 108.53 221.268 110.006C221.268 111.482 222.983 112.826 223.559 113.228C224.135 113.63 223.124 115.376 224.128 117.926C225.133 120.476 225.562 123.698 227.277 123.698C229.053 123.61 230.822 123.43 232.576 123.158L233.434 128.06L245.268 127.052C245.268 127.052 245.127 122.252 248.276 120.206C251.424 118.16 257.658 106.646 253.933 99.128C250.208 91.61 234.58 90.134 227.853 96.308Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.93 90.74C223.542 91.9198 223.386 93.1558 223.469 94.388C223.647 96.7566 224.433 99.0499 225.76 101.072C227.22 103.334 230.714 104.774 231.578 107.186C231.86 107.99 232.576 110.138 234.58 110.678C236.583 111.218 236.16 111.212 235.584 114.836C235.008 118.46 236.73 122.084 240.167 123.026C241.786 123.467 243.495 123.526 245.144 123.198C246.793 122.87 248.331 122.166 249.62 121.148C252.34 119.132 257.492 110.81 257.639 103.292C257.888 89.99 243.904 83.492 231.29 85.112C229.609 85.2683 228.015 85.8854 226.706 86.8864C225.397 87.8873 224.431 89.2277 223.93 90.74Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.098 124.622C237.189 124.651 235.309 125.06 233.581 125.822C231.981 126.614 226.42 131.594 224.986 132.422C223.552 133.25 220.832 132.824 222.426 133.496C224.02 134.168 225.146 134.3 227.866 133.364C230.586 132.428 236.314 130.544 238.029 130.544C239.744 130.544 246.048 131.348 246.624 131.486C247.2 131.624 250.919 133.226 250.919 133.226C250.919 133.226 249.056 129.47 246.912 127.592C244.768 125.714 242.106 124.484 239.098 124.622Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.445 107.918C234.142 108.031 233.887 108.236 233.721 108.5C233.556 108.764 233.488 109.072 233.53 109.376C233.774 111.147 233.741 112.942 233.434 114.704C232.864 116.984 235.904 116.984 236.57 113.246C237.005 110.774 236.007 107.396 234.445 107.918Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.522 138.866C210.522 138.866 208.807 139.67 208.666 143.564C208.525 147.458 201.357 174.848 200.928 179.144C200.5 183.44 202.938 186.254 207.085 187.736C211.232 189.218 219.117 191.624 220.525 190.958C221.933 190.292 224.679 176.456 225.677 170.414C226.676 164.372 214.65 143.414 214.08 142.628C213.511 141.842 211.527 139.004 210.522 138.866Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.834 170.954L211.956 181.964",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.028 219.83L244.973 271.43C245.005 271.591 245.073 271.745 245.173 271.88C245.272 272.014 245.402 272.128 245.552 272.213C245.702 272.297 245.869 272.351 246.043 272.37C246.217 272.389 246.393 272.373 246.56 272.324C246.835 272.24 247.069 272.068 247.223 271.839C247.378 271.611 247.442 271.339 247.405 271.07L240.064 218.714L235.028 219.83Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.988 208.556C223.988 208.556 220.263 255.674 220.263 257.018C220.263 258.362 216.423 272.456 216.423 272.456H226.708C226.708 272.456 227.706 270.578 227.706 266.684C227.706 262.79 228.141 254.468 228.141 253.664C228.141 252.86 239.597 211.238 239.597 211.238C239.597 211.238 239.021 207.074 233.434 204.638C227.847 202.202 224.845 207.482 223.988 208.556Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.706 266.684C227.706 263.126 228.064 255.884 228.128 254.036C223.36 251.528 220.404 254.87 220.404 254.87C220.32 256.07 220.269 256.85 220.269 257.006C220.269 258.35 216.429 272.444 216.429 272.444H226.708C226.708 272.444 227.706 270.578 227.706 266.684Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.708 272.456C226.708 272.456 227.706 270.578 227.706 266.684C227.706 265.238 227.77 263.174 227.84 261.116C226.848 260.03 224.704 258.368 222.413 260.912C221.408 262.022 218.765 269.03 217.504 272.456H226.708Z",
    fill: "#4F4F4F",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.413 260.912L223.271 272.456H225.831L227.988 260.642C227.988 260.642 225.133 257.42 222.413 260.912Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.079 202.4C203.079 202.4 198.637 206.966 198.208 210.86C197.78 214.754 213.101 255.968 213.101 255.968C212.723 257.7 211.886 259.315 210.669 260.666C208.519 263.216 205.511 266.84 205.082 269.258C204.653 271.676 205.082 272.48 205.082 272.48H215.252C215.252 272.48 218.829 263.888 220.263 261.74C221.696 259.592 220.832 255.428 220.404 253.55C219.975 251.672 216.109 208.31 216.109 208.31C216.109 208.31 213.101 199.154 203.079 202.4Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.263 261.716C221.504 259.85 221.024 256.472 220.589 254.384C220.054 253.966 219.423 253.672 218.745 253.523C218.068 253.374 217.362 253.375 216.685 253.526C213.677 254.198 213.101 255.926 213.101 255.926C212.723 257.658 211.886 259.273 210.669 260.624C208.519 263.174 205.511 266.798 205.082 269.216C204.653 271.634 205.082 272.438 205.082 272.438H215.252C215.252 272.438 218.829 263.864 220.263 261.716Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.023 272.456H215.252C215.252 272.456 218.452 264.812 220 262.142C219.232 261.482 216.909 259.796 214.676 261.446C211.956 263.462 211.668 268.43 210.957 270.308C210.618 271.19 210.279 271.922 210.023 272.456Z",
    fill: "#4F4F4F",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.676 261.446L215.252 272.456H217.108L220.256 261.716C220.256 261.716 217.396 259.034 214.676 261.446Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.637 157.064C217.018 164.6 219.156 178.73 219.156 180.05C219.156 182.45 211.668 196.328 211.668 196.328C211.668 196.328 203.348 200.354 201.357 203.174C200.433 204.42 199.891 205.88 199.791 207.395C199.691 208.91 200.035 210.422 200.788 211.766C202.221 214.448 204.365 215.66 209.108 216.464C213.85 217.268 257.792 216.464 257.792 216.464C257.792 216.464 262.375 211.226 260.224 202.904C259.226 199.028 258.138 195.662 256.935 190.958C256.935 190.958 261.658 191.09 265.095 188.402C268.532 185.714 268.679 181.556 268.679 178.472C268.679 175.388 266.516 149.6 266.516 147.056C266.516 144.512 266.388 141.284 263.828 139.4C261.268 137.516 255.2 134.6 249.748 131.888C245.46 129.77 242.304 130.142 238.868 130.142C235.431 130.142 231.277 132.542 231.277 132.542C231.277 132.542 212.231 137.24 210.797 138.044C209.364 138.848 209.876 139.664 210.4 142.628",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.637 157.064C217.018 164.6 219.156 178.73 219.156 180.05C219.156 182.45 211.668 196.328 211.668 196.328C211.668 196.328 203.348 200.354 201.357 203.174C200.433 204.42 199.891 205.88 199.791 207.395C199.691 208.91 200.035 210.422 200.788 211.766C202.221 214.448 204.365 215.66 209.108 216.464C213.85 217.268 257.792 216.464 257.792 216.464C257.792 216.464 262.375 211.226 260.224 202.904C259.226 199.028 258.138 195.662 256.935 190.958C256.935 190.958 261.658 191.09 265.095 188.402C268.532 185.714 268.679 181.556 268.679 178.472C268.679 175.388 266.516 149.6 266.516 147.056C266.516 144.512 266.388 141.284 263.828 139.4C261.268 137.516 255.2 134.6 249.748 131.888C245.46 129.77 242.304 130.142 238.868 130.142C235.431 130.142 231.277 132.542 231.277 132.542C231.277 132.542 212.231 137.24 210.797 138.044C209.364 138.848 209.876 139.664 210.4 142.628",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.213 146.384C259.213 146.384 253.351 178.316 253.351 180.062C253.351 181.808 256.922 190.958 256.922 190.958",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.848 181.4C217.44 185.642 211.668 196.328 211.668 196.328C211.668 196.328 203.348 200.354 201.357 203.174C200.433 204.42 199.891 205.88 199.791 207.395C199.691 208.91 200.035 210.422 200.788 211.766C202.221 214.448 204.365 215.66 209.108 216.464C213.85 217.268 257.792 216.464 257.792 216.464C257.792 216.464 262.375 211.226 260.224 202.904C259.226 199.028 258.138 195.662 256.935 190.958L253.351 181.4H218.848Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.516 219.284L199.111 271.274C199.088 271.437 199.103 271.602 199.154 271.76C199.205 271.917 199.291 272.062 199.407 272.185C199.523 272.308 199.665 272.407 199.825 272.475C199.985 272.542 200.158 272.577 200.333 272.576C200.621 272.577 200.9 272.484 201.121 272.312C201.342 272.139 201.492 271.899 201.543 271.634L211.668 219.686L206.516 219.284Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.508 219.284L262.912 271.274C262.935 271.437 262.921 271.602 262.87 271.76C262.819 271.917 262.732 272.062 262.616 272.185C262.501 272.308 262.358 272.407 262.198 272.475C262.039 272.542 261.865 272.577 261.69 272.576C261.402 272.577 261.123 272.484 260.902 272.312C260.681 272.139 260.532 271.899 260.48 271.634L250.388 219.686L255.508 219.284Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.708 219.284L219.303 271.274C219.28 271.437 219.295 271.602 219.346 271.76C219.397 271.917 219.483 272.062 219.599 272.185C219.715 272.308 219.857 272.407 220.017 272.475C220.177 272.542 220.35 272.577 220.525 272.576C220.813 272.576 221.091 272.482 221.312 272.31C221.533 272.138 221.682 271.899 221.735 271.634L231.86 219.686L226.708 219.284Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.508 159.8H217.255C217.255 159.8 215.975 170 216.685 178.73C217.396 187.46 218.976 198.596 218.688 205.73C218.4 212.864 214.106 216.74 214.106 216.74H203.796C203.551 216.739 203.309 216.784 203.083 216.871C202.857 216.958 202.652 217.086 202.479 217.247C202.306 217.409 202.169 217.601 202.075 217.813C201.981 218.024 201.933 218.251 201.933 218.48C201.933 218.709 201.981 218.936 202.075 219.148C202.169 219.36 202.306 219.552 202.479 219.715C202.652 219.877 202.857 220.005 203.083 220.093C203.309 220.181 203.551 220.226 203.796 220.226H259.476C262.851 215.122 264.497 209.179 264.199 203.18C263.77 192.98 259.476 181.43 260.903 173.24C262.33 165.05 263.508 159.8 263.508 159.8Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.264 97.454C251.264 97.454 248.404 98.528 248.256 101.054C248.109 103.58 247.258 112.328 243.821 117.296C240.384 122.264 243.821 130.184 252.269 131.39C260.717 132.596 267.591 120.65 264.429 108.302C261.268 95.954 254.132 96.38 251.264 97.454Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5476 272.576H302.439",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_2282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 300,
    fill: "white",
    transform: "translate(31 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockInterview);
export default __webpack_public_path__ + "static/media/MockInterview.29ef7b74ddcf2aff00169b26a3343e27.svg";
export { ForwardRef as ReactComponent };